import React from 'react'
import InformationBanner from '../../../react4xp/components/InformationBanner'

function InformationBannerPart({ color, imageSrc, imageSrcLarge, imageSrcMedium, imageSrcSmall, intro, text, title }) {
  return (
    <InformationBanner
      bgColor={color}
      image={imageSrc?.link && {
        srcSmall: imageSrcSmall?.link,
        srcMedium: imageSrcMedium?.link,
        srcLarge: imageSrcLarge?.link,
        src: imageSrc?.link,
        alt: imageSrc?.alt,
      }}
      title={title}
      intro={intro}
      content={text}
    />
  )
}

export default (props) => <InformationBannerPart {...props} />
